import {  
  GET_INFO_ANALYTIC_PREVIO,
  SET_INFO_ANALYTIC,
  SET_LOADING_TRUE,
  SET_LOADING_FALSE
} from '../types'

export default function consultarCasosAnalyticReducer(state = {}, action) {
  switch (action.type) {    
    case SET_LOADING_TRUE:
      return { ...state, loading: true }
    case SET_LOADING_FALSE:
      return { ...state, loading: false }
    case GET_INFO_ANALYTIC_PREVIO:
      return { ...state, infoAnalyticPrevio: action.payload }
    case SET_INFO_ANALYTIC:
      return { ...state, ingresoInfoAnalytic: action.payload }
    default:
      return state
  }
}
